<template>
  <div class="collapsible-text-list-inner">
    <div class="collapsible-parent">
      <div ref="contentRef" :class="{ 'collapsible-content': isCollapsible, expanded: isOpen && isCollapsible }">
        <slot :is-open="isOpen" />
      </div>
      <div v-if="!isOpen && isCollapsible" class="fade-bottom"></div>
    </div>
    <div v-if="isCollapsible" class="partial-collapse-toggle">
      <button :aria-expanded="isOpen" @click="toggle">
        <div v-if="isOpen">
          <span>−</span>
          <span class="underlined">閉じる</span>
        </div>
        <div v-else>
          <span>＋</span>
          <span class="underlined">続きを読む</span>
        </div>
      </button>
    </div>
  </div>
</template>

<script setup lang="ts">
const props = withDefaults(
  defineProps<{
    collapsedHeight?: number
    expandedHeight?: string
  }>(),
  {
    collapsedHeight: 100,
    expandedHeight: 'revert'
  }
)

const isOpen = ref(false)
const isCollapsible = ref(true)
const contentRef = ref<HTMLElement | null>(null)

const checkCollapsible = (el: HTMLElement | null): boolean => {
  if (!el) return false
  return el.scrollHeight > props.collapsedHeight
}

onMounted(async () => {
  await nextTick()
  isCollapsible.value = checkCollapsible(contentRef.value)
})

const toggle = () => {
  isOpen.value = !isOpen.value
}

const isValidMaxHeight = (val: string): boolean => {
  return /^\s*(\d+(\.\d+)?(px|em|rem|vh|vw|%|ch|ex|vmin|vmax|fr)?|auto|none|fit-content|min-content|max-content|revert|inherit|initial|unset)\s*$/i.test(
    val
  )
}

const expandedStyle = computed(() => ({
  maxHeight: isValidMaxHeight(props.expandedHeight) ? props.expandedHeight : 'revert'
}))
</script>

<style lang="scss" scoped>
.partial-collapse-toggle {
  display: flex;
  justify-content: center;

  button {
    background: none;
    border: none;
    cursor: pointer;
    font-size: 16px;
    text-align: center;
    color: $black-1a;
  }
}

.collapsible-content {
  max-height: v-bind('`${$props.collapsedHeight}px`');
  overflow-y: hidden;
}

.collapsible-content.expanded {
  max-height: v-bind('expandedStyle.maxHeight');
  overflow-y: scroll;
}

.fade-bottom {
  position: absolute;
  height: 48px;
  width: 100%;
  transform: translateY(-48px);
  background: linear-gradient(to bottom, rgba(255, 255, 255, 0), #fff 90%);
  pointer-events: none;
}

.collapsible-content.expanded .fade-bottom {
  display: none;
}

.underlined {
  text-underline-offset: 0.2em;
  text-decoration: underline;
}

.collapsible-parent {
  position: relative;
}

.collapsible-text-list-inner {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
</style>
